import React from 'react'
import advantageImg1 from 'images/team-landing/advantages/advantage-img-1.png'
import advantageImg2 from 'images/team-landing/advantages/advantage-img-2.png'
import advantageImg3 from 'images/team-landing/advantages/advantage-img-3.png'

const AdvantagesSection = () => {
  return (
    <div className='tl-advantages-section' data-aos="fade-up">
        <h1>Mucho más que consultas de terapia gratuitas</h1>
        <div className="tl-advantages-container">
            <div className="tl-advantage-block">
                <img src={advantageImg1} alt="" />
                <h3>Salud mental y emocional</h3>
                <p>Cuida la salud mental y emocional de tus colaboradores a través de asesoría y consultas psicológicas. Soporte para condiciones derivadas del estrés, ansiedad, depresión, adicciones, trastornos de sueño, y mucho más.</p>
            </div>
            <div className="tl-advantage-block">
                <img src={advantageImg2} alt="" />
                <h3>Salud nutricional</h3>
                <p>Porque el bienestar emocional no se puede separar de una buena nutrición, en Terapi entregamos a tus colaboradores el acceso directo a un nutricionista para crear programas alimentarios y buenos hábitos que mejoren el bienestar de tus empleados.</p>
            </div>
            <div className="tl-advantage-block">
                <img src={advantageImg3} alt="" />
                <h3>Salud financiera</h3>
                <p>Una de los principales factores que afectan la salud mental de todos en la vida moderna son los problemas financieros. Apoya a tus colaboradores a través de asesores financieros que los ayudarán a tomar las mejores decisiones que cuiden sus bolsillos y bienestar mental.</p>
            </div>
        </div>
    </div>
  )
}

export default AdvantagesSection